import React from 'react';
import { Grid } from '@mui/material';
import {
    SimpleDialog,
    ButtonLoading
} from 'components';
import { createSanitizeHtml } from 'utility';
import { makeStyles } from '@mui/styles';
import { useNavigate } from 'react-router-dom';

const useStyles = makeStyles((theme) => {
    return {

        customClassdialogContent: {
            minWidth: '440px',
            [theme.breakpoints.down('sm')]: {
                minWidth: 'auto',
            },
        }

    };
});
const CartableMessageDg = (props) => {
    const { isOpenDg, setIsOpenDg, requestId, isGroup = false, isCartable = false } = props;
    const classes = useStyles();
    const navigate = useNavigate();

    const boldFont = (str) => {
        return `<span style='unicode-bidi: embed;direction: ltr;font-weight:bold'>${str}</span>`;
    };

    const textGroupMessage = `پس از اتمام عملیات، پیامک اطلاع رسانی ارسال خواهد شد. همچنین میتوانید از طریق لینک ${boldFont('جزئیات')} در صفحه ${boldFont('عملیات گروهی')}، نتیجه عملیات را مشاهده نمایید.`;
    const textGroupMessageCartable = 'درخواست شما در حال تایید توسط امضاداران می باشد. جهت مشاهده جزئیات درخواست، بر روی دکمه زیر کلیک نمایید.'
    const singleCartable = 'درخواست شما در حال تایید توسط امضاداران می باشد. جهت مشاهده جزئیات درخواست، بر روی دکمه زیر کلیک نمایید.';
    const getMessage = () => {
        if (isGroup) {
            if (isCartable) {
                return createSanitizeHtml(textGroupMessageCartable);
            } else {
                return createSanitizeHtml(textGroupMessage);
            }
        } else {
            return createSanitizeHtml(singleCartable);
        }
    }
    return (


        <SimpleDialog
            fullWidth
            maxWidth="xs"
            customClass={classes.customClassdialogContent}
            open={isOpenDg}
            title='درخواست تفویض وجه'
            onClose={() => setIsOpenDg(false)}

        >


            <Grid container alignItems="center" >
                <Grid style={{ position: 'relative', width: '100%' }}>
                    <Grid style={{ textAlign: 'center' }}>
                        <div dangerouslySetInnerHTML={{ __html: getMessage() }}></div>
                    </Grid>
                    <Grid md={12} xs={12} lg={12}
                        style={{ display: 'flex', marginTop: '16px' }}
                    >

                        <ButtonLoading
                            type="button"
                            variant="contained"
                            color="primary"
                            style={{ width: '100%' }}
                            name="جزئیات درخواست "
                            onClick={() => {
                                setIsOpenDg(false);
                                if (isGroup) {//CONTACT, CONTACT_CARTABLE, DELEGATION, DELEGATION_CARTABLE
                                    navigate(`/GroupDelegationList`);
                                } else {

                                    navigate(`/RequestPayDetails/${requestId}`);
                                }
                            }}
                        />

                    </Grid>
                </Grid>
            </Grid>


        </SimpleDialog>
    )
}

export default CartableMessageDg;

